export enum CustomerEtaConfiguration {
  None = 'NONE',
  Google = 'GOOGLE',
  Custom = 'CUSTOM'
}
